/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionConsent,
  UserSessionConsent$inboundSchema,
} from "./usersessionconsent.js";

/**
 * Result type for listing user_session_consents.
 */
export type ListUserSessionConsentsResult = {
  items: Array<UserSessionConsent>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUserSessionConsentsResult$inboundSchema: z.ZodMiniType<
  ListUserSessionConsentsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(UserSessionConsent$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listUserSessionConsentsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionConsentsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionConsentsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionConsentsResult' from JSON`,
  );
}
